import jsPDF from "jspdf";
import "jspdf-autotable";
import { numberWithCommas } from "../helpers/app/numberFormater";
import image from "../../assets/logo/authLogo.png";
import { centrePdfText } from "../helpers/app/pdf";
import dayjs from "dayjs";

const generateIncomeStatementPdf = (data, startDate, endDate) => {
  const doc = new jsPDF();
  doc.setFontSize(10);
  doc.addImage(image, "PNG", 60, 15, 80, 25);
  centrePdfText(
    doc,
    "P.O.BOX 610029, Maracha, Uganda | Adongoro Cell, Maracha Town Council",
    45
  );
  centrePdfText(doc, "Mob: +256 393102379", 60);
  centrePdfText(
    doc,
    "Web: www.amaniinitiative.org | Email: info.amaniinitiative@gmail.com",
    65
  );
  centrePdfText(doc, "AMANI INITIATIVE INCOME STATEMENT", 75);
  doc.text(
    `Period: ${dayjs(startDate).format("DD MMMM YYYY")} to ${dayjs(endDate).format("DD MMMM YYYY")}`,
    14,
    85
  );

  const income = data?.income || {};
  const expenditure = data?.expenditure || {};
  const incomeItems = income?.items || [];
  const expenditureItems = expenditure?.items || [];
  const totalIncome = income?.total || 0;
  const totalExpenditure = expenditure?.total || 0;
  const surplusDeficit = data?.surplusDeficit || 0;

  let startY = 95;

  // Income Section
  doc.setFontSize(12);
  doc.text("INCOME", 14, startY);
  startY += 8;

  const incomeColumns = ["Account Name", "Amount (UGX)"];
  const incomeRows = [];

  incomeItems.forEach((item) => {
    incomeRows.push([item.accountName || "", item.amount ? numberWithCommas(item.amount) : "0"]);
  });

  incomeRows.push(["TOTAL INCOME", numberWithCommas(totalIncome)]);

  doc.autoTable(incomeColumns, incomeRows, { startY });

  let { finalY: incomeFinalY } = doc.lastAutoTable;
  startY = incomeFinalY + 15;

  // Expenditure Section
  doc.setFontSize(12);
  doc.text("EXPENDITURE", 14, startY);
  startY += 8;

  const expenditureColumns = ["Account Name", "Amount (UGX)"];
  const expenditureRows = [];

  expenditureItems.forEach((item) => {
    expenditureRows.push([
      item.accountName || "",
      item.amount ? numberWithCommas(item.amount) : "0",
    ]);
  });

  expenditureRows.push(["TOTAL EXPENDITURE", numberWithCommas(totalExpenditure)]);

  doc.autoTable(expenditureColumns, expenditureRows, { startY });

  let { finalY: expenditureFinalY } = doc.lastAutoTable;
  startY = expenditureFinalY + 20;

  // Surplus/Deficit Summary
  doc.setFontSize(12);
  doc.text(
    `${surplusDeficit >= 0 ? "SURPLUS" : "DEFICIT"} FOR THE PERIOD:`,
    14,
    startY
  );
  doc.setFontSize(14);
  if (surplusDeficit >= 0) {
    doc.setTextColor(82, 196, 26); // Green
  } else {
    doc.setTextColor(255, 77, 79); // Red
  }
  doc.text(`UGX ${numberWithCommas(Math.abs(surplusDeficit))}`, 100, startY);
  doc.setTextColor(0, 0, 0); // Reset to black

  startY += 10;
  doc.setFontSize(10);
  doc.text(`Total Income: UGX ${numberWithCommas(totalIncome)}`, 14, startY);
  doc.text(`Total Expenditure: UGX ${numberWithCommas(totalExpenditure)}`, 100, startY);

  const fileName = `INCOME_STATEMENT_${dayjs(startDate).format("YYYY-MM-DD")}_TO_${dayjs(endDate).format("YYYY-MM-DD")}.pdf`;
  doc.save(fileName);
};

export default generateIncomeStatementPdf;

